Wee.fn.make('newsletter', {
	init: function() {
		var	scope = this,
			$form = $('ref:newsletterForm'),
			results = [],
			rules = [
				[
					'.js-first-name',
					'required'
				],
				[
					'.js-last-name',
					'required'
				],
				[
					'.js-email',
					'required|email'
				],
				[
					'.js-email-confirm',
					'required|email|confirm:js-email'
				]
			];

		if ($.get('formType') === 'CS') {
			rules.push([
				'.js-school-name',
				'required'
			]);

			rules.push([
				'.js-zipcode',
				'required|numeric'
			]);
		}

		Wee.infieldLabels.init();

		$.events.on({
			'ref:newsletterModalToggle': {
				click: function() {
					var $email = $('ref:email');

					if ($email.val() === '') {
						$email.val($('ref:initialEmail').val());
					}
				}
			},
			'ref:newsletterForm': {
				submit: function(e, el) {
					var $form = $form;

					results = Wee.validate.run(rules);

					$('.form-input-error').hide();
					$('.js-modal-input').removeClass('-has-error');

					if (! results.length) {
						scope.submitForm(el);
					} else {
						for (i = 0; i < results.length; i++) {
							modifier = '-' + results[i][1] + '-error';

							$(results[i][0] + modifier).show();
							$(results[i][0]).addClass('-has-error');
						}

					}

					e.preventDefault();
				}
			}
		});
	},

	submitForm: function(el) {
		var scope = this,
			$form = $(el);

		scope.toggleButton();

		$.fetch.request({
			url: $form.attr('action'),
			method: 'post',
			data: $form.serialize(),
			type: 'text',
			success: function(data) {
				scope.showSuccessMessage();

				// Enable button
				scope.toggleButton();
			},
			error: function(data) {
				$('ref:newsletterGlobalError').text('There was a problem submitting your form');

				// Enable button
				scope.toggleButton();
			}
		});

		setTimeout(function() {
			scope.toggleButton();
		}, 5000);
	},

	toggleButton: function() {
		var $button = $('ref:registerButton');

		if ($button.prop('disabled')) {
			$button.prop('disabled', false)
				.text('Submit');
		} else {
			$button.prop('disabled', true)
				.text('Submitting...');
		}
	},

	showSuccessMessage: function() {
		Wee.modal.close();

		$('ref:newsletter').html(
			$.view.render('newsletter-thank', {
				heading: $.get('thankYouHeading'),
				body: $.get('thankYouBody')
			}
		));
	}
});
